import { react } from "uikit";
import { Dispatch } from "react";

import CompanyAndTaxiService from ".";

interface Context {
	value: CompanyAndTaxiService.Value;
	setError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isValid =
			this.context?.value.companyIds.length === 1 &&
			this.context?.value.taxiServiceIds.length === 1;

		if (!isValid) this.context?.setError(true);

		return !!isValid;
	}
}
